import { StoreAndGroupType } from './context.types';

export type Action = {
  type: 'SET_STORES' | 'SET_STORES_AND_PAGES' | 'SET_STORES_AND_GROUP' | 'UNKNOWN_ACTION';
  stores?: string[];
  storeAndPage?: { storeNumber: string; page: number };
  storesAndGroups?: StoreAndGroupType;
};

export interface State {
  stores: string[];
  storesAndPages: Map<string, number>;
  storesAndGroups: StoreAndGroupType;
}

export const initialState: State = {
  stores: [],
  storesAndPages: new Map<string, number>(),
  storesAndGroups: { origin: '', storeGroups: [], stores: [] },
};

export function Reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_STORES': {
      const stores = [...(action.stores || [])];
      return {
        ...state,
        stores,
      };
    }

    case 'SET_STORES_AND_PAGES': {
      const { storesAndPages } = state;
      let updatedStoresAndPages = storesAndPages;

      if (!state.storesAndPages || !state.storesAndPages.get) {
        updatedStoresAndPages = new Map<string, number>();
      }
      updatedStoresAndPages.set(action.storeAndPage?.storeNumber || '', action.storeAndPage?.page || 0);

      return {
        ...state,
        storesAndPages: updatedStoresAndPages,
      };
    }

    case 'SET_STORES_AND_GROUP': {
      const { storesAndGroups } = state;
      let updatedStoresAndGroup = storesAndGroups;

      updatedStoresAndGroup = {
        origin: action.storesAndGroups?.origin || '',
        storeGroups: action.storesAndGroups?.storeGroups,
        stores: action.storesAndGroups?.stores,
        countByStoreGroup: action.storesAndGroups?.countByStoreGroup,
      };

      return {
        ...state,
        storesAndGroups: updatedStoresAndGroup,
      };
    }

    default:
      return state;
  }
}
